export default __webpack_public_path__ + "static/media/d9.b7bc366c.jpg";